<template>
  <ul :class="[insideList ? 'inside_list' : 'list', { row_list: moreRows }]">
    <h3 v-if="!!title" class="title_text" :class="[insideList && 'bold_text']">
      {{ $t(title) }}:
    </h3>
    <li
      v-for="(item, index) in list instanceof Array
        ? translateWithVariables
        : $tm(list, translatePayload)"
      class="list-item"
      :key="index"
      :class="[
        {
          'align-items-start col-12 col-md-6 col-lg-4 ': moreRows,
        },
      ]"
    >
      <div class="icon_container">
        <b-icon-check-circle-fill viewBox="-1 -1 18 18" class="item_icon" />
      </div>
      <div class="text_container">
        <span
          v-if="typeof item === 'string'"
          class="item_text"
          v-html="$t(item, translatePayload)"
        />
        <!-- LIST INSIDE THIS LIST -->
        <ul v-else class="inside_list">
          <h4 class="text mb-2">{{ item.value }}:</h4>
          <li
            v-for="(i, index) in item.list"
            :key="index"
            class="item_text"
            v-html="i"
          />
        </ul>
      </div>
    </li>
    <slot />
  </ul>
</template>

<script setup>
import { computed } from "vue";
import { useWindowSize } from "@vueuse/core";

const { width } = useWindowSize();

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  list: {
    type: Array,
    default: () => [],
  },
  row: {
    type: Number,
    default: 1,
  },
  insideList: {
    type: Boolean,
    default: false,
  },
  translatePayload: {
    type: Object,
    default: () => ({}),
  },
});

const translateWithVariables = computed(() => {
  const variablesList = Object.keys(props.translatePayload);

  if (!variablesList.length) {
    return props.list;
  }
  return props.list?.map((text) => {
    let translatedText = text;
    variablesList.forEach((variable) => {
      translatedText = translatedText.replace(
        `{ ${variable} }`,
        props.translatePayload[variable]
      );
    });
    return translatedText;
  });
});

const moreRows = computed(() => props.row > 1 && width.value > 800);
</script>

<style flex-start lang="scss" scoped>
.list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 23px 22px 33px;
  width: 50%;
  min-width: 880px;
  border-radius: 11px;
  background-color: var(--block-color);
  box-shadow: 0 10px 13px rgba(122, 112, 223, 0.22);

  @media screen and (max-width: 1024px) {
    width: 100%;
    min-width: unset;
  }

  &-item {
    display: flex;
    align-items: center;
    gap: 14px;
  }
}

.inside_list {
  display: flex;
  flex-direction: column;
  /* gap: 5px; */
  margin-top: 5px;
  list-style-type: circle;
  list-style-position: inside;

  .item_text {
    margin: 3px 0 auto 0;
    line-height: 1.5;
  }
}

.icon_container {
  align-self: baseline;
}

.row_list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 30px;
  /* gap: 20px */
  /* align-items: flex-end; */
}

.item_icon {
  width: 30px;
  height: 30px;
  color: var(--general-color);
}

.title_text {
  font-size: 20px;
  margin-top: 24px;
  font-weight: 500;
  width: 100%;
}

.bold_text {
  font-weight: 700;
  font-size: 24px;
}

.text_container {
  font-family: "Gilroy";
  font-size: 16px;
  font-weight: 500;
  color: var(--text-second-color);
  vertical-align: middle;
}
</style>
